import { v4 as uuidv4 } from 'uuid'

export function getStatisticCard(history) {
  return [
    {
      id: uuidv4(),
      add: false,
      title: 'Communities',
      action: () => {
        history.push('/followed/community')
      },
      img: '',
      icon: 'heart',
      isComing: false,
    },
    {
      id: uuidv4(),
      add: false,
      title: 'Events',
      action: () => {
        history.push('/followed/events')
      },
      img: '',
      icon: 'heart',
      isComing: false,
    },
    {
      id: uuidv4(),
      add: false,
      title: 'Tournaments',
      action: () => {
        history.push('/followed/tournaments')
      },
      img: '',
      icon: 'heart',
      isComing: false,
    },
    {
      id: uuidv4(),
      add: false,
      title: 'Users',
      action: () => {
        history.push('/followed/users')
      },
      img: '',
      icon: 'heart',
      isComing: false,
    },
  ]
}
